/**
 * Genesis / Mega Drive ROMs that CANNOT be faithfully recorded as replays.
 *
 * Solo replays log input as a per-player uint16 RetroPad joypad bitmask. Genesis
 * is otherwise a clean digital-pad system (3- and 6-button pads fit the bitmask),
 * but the Menacer / Justifier LIGHT-GUN titles read an aimed pointer that the
 * joypad bitmask can't represent — a recorded log would replay with a frozen
 * crosshair and desync. Same root limitation as Atari's paddle/light-gun titles.
 *
 * Mouse-capable Genesis games (Cannon Fodder, Lemmings, Populous, …) are NOT
 * listed: on Genesis they are fully playable — and faithfully recordable — with
 * the control pad, which IS captured.
 *
 * Recording is the only producer of replays, so blocking these in
 * App._shouldRecordSolo() guarantees no broken replay is ever created; they fall
 * back to the normal self-driving path (no recording).
 *
 * Keyed by the 8-char FNV-1a `romHash` (EmulatorCore.hashROM), sourced verbatim
 * from rom-index/genesis.json. To extend: add a game's `hash` from that file.
 */
export const GENESIS_NON_JOYPAD_ROM_HASHES = new Set([
  // ── Light gun (Menacer / Justifier) ────────────────────────────
  '2bd23c22', // Lethal Enforcers (E)
  '670631d2', // Lethal Enforcers (U)
  '18429b8c', // Lethal Enforcers II - Gun Fighters (E)
  'f2c1f490', // Lethal Enforcers II - Gun Fighters (U)
  '71a92d20', // Menacer 6-in-1 Game Pack (UE)
  '83fabe58', // Body Count (E)
  '29ff6858', // T2 - The Arcade Game (UE)
]);
